import { render, staticRenderFns } from "./lv-base-column.vue?vue&type=template&id=73289990&"
import script from "./lv-base-column.vue?vue&type=script&lang=js&"
export * from "./lv-base-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports